import { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import useAlert from 'utils/alert';
import useDeleteLedger from 'utils/ledger/use-delete-ledger-entry';

const initialstate = {
  entryLedger: null,
  mode: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'edit':
      return {
        mode: 'edit',
        entryLedger: action.entryLedger,
      };
    case 'delete':
      return {
        mode: 'delete',
        entryLedger: action.entryLedger,
      };
    case 'new':
      return {
        mode: 'new',
        entryLedger: null,
      };
    default:
      return {
        entryLedger: null,
        mode: null,
      };
  }
};
const useMortgageItems = (mortgateId: string) => {
  const [state, dispatch] = useReducer(reducer, initialstate);
  const queryCache = useQueryClient();
  const { id } = useParams<{ id: string }>();
  const showAlert = useAlert();
  const { t } = useTranslation();
  const { deleteEntry, deleteEntryResponse } = useDeleteLedger(() => {
    dispatch({ type: null, entryLedger: null });
    showAlert(t('payoffs:success-deleted'), 'success');
    // queryCache.invalidateQueries(['order-mortgages', id],);
  });

  useEffect(() => {
    dispatch({ type: null, entryLedger: null });
  }, [mortgateId]);

  return {
    state,
    dispatch,
    deleteEntry,
    isDeleting: deleteEntryResponse.isLoading,
    id,
    queryCache,
  };
};

export default useMortgageItems;
